<template>
	<div>
		<van-nav-bar title="货位变更" left-text="返回" left-arrow @click-left="onClickLeft" fixed />
		<div class="psiConfirmCont">
			<div style="display: flex;">
				<van-field v-model="position" center clearable autofocus ref="positionInput" label="货位" placeholder="请输入货位条码">
				</van-field>
			</div>
			<div style="display: flex;">
				<van-field v-model="value" center clearable label="条码" ref="barcodeInput" placeholder="请输入条码">
					<template #button>
						<van-button size="small" type="info" @click="confirm">确定</van-button>
				  	</template>
				</van-field>
			</div>
		</div>
	</div>
</template>

<script>
	import {NavBar, Field, Button, List, PullRefresh,Toast} from 'vant';
    import barcodeService from "../../service/barcodeService";
	export default {
		data() {
			return {
				position: '',
				value: '',
				tempPosition: "",
				tempValue: "",
				positionId: ""
			};
		},
		mounted: function () {
			this.$refs.positionInput.focus();
			let that = this;
			document.onkeydown = function(event) {
			    if (event.keyCode == 13) {
					that.tempPosition = that.position;
					that.tempValue = that.value;
					if(that.tempPosition.length > 0){
						if(that.tempPosition.indexOf("HW") < 0 && that.positionId.indexOf("HW") < 0){
							that.value = that.tempPosition;
							this.position = "";
						}
					}
					if(that.tempValue.length > 0){
						if(that.tempValue.indexOf("HW") > -1){
							that.position = that.tempValue;
							that.value = "";
						}
					}
				   if(that.position.length>0 && that.value.length==0){
                       that.$refs.barcodeInput.focus();
				   }else{
                       that.confirm();
				   }
			   }
			}
		},
		components: {
			[NavBar.name]: NavBar,
			[Field.name]: Field,
			[Button.name]: Button,
            [List.name]: List,
            [PullRefresh.name]: PullRefresh
		},
		methods: {
			onClickLeft() {
			    this.$router.go(-1);
			},
			async confirm(){
				if(!this.value){
					return ;
				}
				let resp = await barcodeService.storageChange(this.value, this.position);
	            if (resp.data.Status === "1"){
                	Toast.success('货位变更成功！');
					this.value = '';
                    this.$refs.barcodeInput.focus();
	            } else {
					/*top.location.href = "/audio/alert";*/
                	Toast.fail(resp.data.Message);
					this.value = '';
                	if(this.position.length==0){
                        this.$refs.positionInput.focus();
					}else{
                        this.$refs.barcodeInput.focus();
					}
	            }
			}
		},
		watch: {
			async position(){
				let resp = await barcodeService.getPositionById(this.position);
				if (resp.data.Status === "1"){
					this.position = resp.data.Data.name;
					this.positionId = resp.data.Data.uuid;
				}
			}
		}
	}
</script>

<style scoped>
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:120px;
		overflow: hidden;
	
	}
</style>
